<template>
  <div class="youfuwu">
    <topTitle title="五有服务" :list="list" :newData="newData"></topTitle>
    <p class="top_p">
        钱湖柏庭严格遵循美国养老社区标准，遴选小柏家护精英护理团队，以强大专业精神，构筑完善服务体系。
    </p>
    <div class="item" v-for="(item, key) in list2" :key="key">
      <div class="item_top">
        {{ item.title }}
        <div class="seKuai"></div>
      </div>
      <div class="item_bd">
        <img :src="item.img" alt="" />
        <div class="item_content">
            <div class="content_title">{{item.small_title}}</div>
            <p class="content">{{item.content}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
export default {
  name: "youfuwu",
  data() {
    return {
      list: [
          {
              title: "【五有】有套房",
              small_title: "HAVE A SUITE",
              hasTitle: "有套房",
          },
          {
              title: "【五有】有块地",
              hasTitle: "有块地",
          },
          {
              title: "【五有】有地暖",
              hasTitle: "有地暖",
          },
          {
              title: "【五有】有社团",
              small_title: "HAVE A CLUB",
              hasTitle: "有社团",
          },
          {
              title: "【五有】有管家",
              small_title: "HAVE A BUTLER",
              hasTitle: "有管家",
          }
      ],
      newData: 4,
      list2: [
        {
          title: "生活",
          small_title: "·细节化的生活服务",
          content:
            "  钱湖柏庭衣食住行生活配套设施全方位配备，配有精品酒店、四大餐厅、生鲜超市、理发、干洗、园区班车、园区内助力观光车等。精品酒店便于子女或亲戚朋友探望入住，亦可为入住长者提供餐饮休闲娱乐服务；四大餐厅分布在各个组团厅堂内，便于就近就餐；在生鲜超市里，除可采购日常生活用品采购外，亦能满足入住长者日常买菜需求；园区...",
          img: require("../../assets/image/fuwu/fuwu_1.png"),
        },
        {
          title: "健康",
          small_title: "·专业化的健康服务",
          content:
            "  集养老、养生、医疗、康复为一体，钱湖柏庭美国35年高端养老行业经验，全产业链的养老布局，以医养结合的创新模式，构筑全方位健康生活堡垒。在宁波，钱湖柏庭先后与宁波李惠利东部医院、宁波市老医药卫生工作者协会签订“医养合作”协议。宁波李惠利东部医院是由著名的台北医学大学双和医院运营管理的大型综合性公立医院...",
              img: require("../../assets/image/fuwu/fuwu_2.png"),
        },
        {
          title: "物业",
          small_title: "·贴心的物业服务",
          content:
            "  园区将提供衣、食、住、行、学、医、游、娱全方位体贴入微的物业服务，给予入住长者家人般的爱护与照顾。",
              img: require("../../assets/image/index/fuwu_5.png"),
        },
      ],
    };
  },
  methods: {},
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {
   
  },
};
</script>
<style scoped="scoped">
.youfuwu {
}
.top_p {
  margin-top: 0.675rem;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  text-align: left;
  text-indent: 2em;

  line-height: 0.675rem;
}
.item {
  width: 100%;
  height: 6.475rem;
  border-bottom: 1px solid #dcdcdc;
  padding-top: 0.5375rem;
}
.item:last-child{
    border: none;
}
.item_top {
  font-size: 0.525rem;
  font-family: PingFang SC;
  font-weight: 600;
  color: #40684b;
  line-height: 54px;
  text-align: left;
  position: relative;
  margin-bottom: 0.6875rem;
}
.seKuai {
  position: absolute;
  width: 1.4875rem;
  height: 0.3875rem;
  background: #40684b;
  opacity: 0.24;
  top: 0.4rem;
  left: 0.25rem;
}
.item_bd{
    display: flex;
    height: 3.825rem;
    align-items: center;
    
}
.item_bd img{
    width: 4.9rem;
/* height: 3.675rem; */
border-radius: 10px;
margin-right: 0.625rem;
}
.item_content{
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
}
.content_title{
font-size: 0.4rem;
font-family: PingFang SC;
font-weight: 500;
color: #40684B;
line-height: 43px;
}
.content{
font-size: 0.3rem;
font-family: PingFang SC;
font-weight: 400;
color: #333333;
line-height: 0.4625rem;
text-indent: 2em;
}
</style>